module.exports = __webpack_public_path__ + "img/undraw_processing_qj6a.66d95e6f.svg";